import axios from "axios";
import env from "../variables/EndpointEnvironment";

const headers = {
  "Content-Language": localStorage.getItem('i18nextLng'),
}

const PromotionAPI = (props) => {
 
  return axios.get(
    `${env.HOST}/promotion${props}`,
    {
      headers
    }
  );
};

export default PromotionAPI;
